// Core
import { useState, useCallback } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import {
  Divider,
  Text,
  SimpleGrid,
  Skeleton,
  useColorModeValue,
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import OptionRow from './components/SystemSettingsRow';
import NotFound from 'views/Dashboard/404.js';

const SystemSettings = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const [offset, setOffset] = useState(0);
  const limit = 19;
  const [systemSettings, setSystemSettings] = useState([]);
  const history = useHistory();

  const onRowClicked = useCallback(
    (option) => {
      history.push(`/system-settings/${option.todo}`);
    },
    [history],
  );

  const { refetch, isLoading } = useQuery({
    queryKey: ['system-settings', offset],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const data = {
        limit,
        offset,
      };

      const response = await apiService.getSystemSettings(data);
      setSystemSettings(response.data);
      return true;
    },
  });

  const settingsArray = Object.entries(systemSettings) || [];

  return (
    <>
      <Text
        fontSize="40px"
        fontStyle="normal"
        fontWeight="700"
        color={textColor}
        mb="0px"
        className="page-name"
      >
        System Settings
      </Text>
      <Divider
        opacity="1"
        mr="2px"
        borderColor={borderColor}
        borderTopWidth="1px"
        borderBottomWidth="0"
        mb="32px"
      />

      {isLoading && offset === 0 ? (
        <SimpleGrid columns={1} spacing="8px">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} h="187px" borderRadius="20px" />
          ))}
        </SimpleGrid>
      ) : (
        <>
          {settingsArray?.length > 0 ? (
            <SimpleGrid columns={1} spacing="8px">
              {settingsArray?.map((page) => (
                <OptionRow
                  handleEditOpen={onRowClicked}
                  key={page.id}
                  page={page}
                  refetch={refetch}
                />
              ))}
            </SimpleGrid>
          ) : (
            <NotFound text="Not Found" />
          )}
        </>
      )}
    </>
  );
};

export default SystemSettings;
